import { deliveryNoteBusiness } from "api/bussiness/delivery-note/delivery-note-business";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type {
  PaginationSearchRequest,
  PaginationSearchResult,
} from "share-components/mui-wrap/auto-complete/x-auto-complete-with-pagination";

export const searchDeliveryNoteNumberOptions = async (keyword: string) => {
  const res = await deliveryNoteBusiness.searchDeliveryNotes(keyword);
  return mapToDistinctOptionItems(
    res.items?.filter((x) => x.number),
    (x) => x.number,
  );
};

export const searchDeliveryNoteNumberOptionsWithPagination = async (
  keyword: string,
  request: PaginationSearchRequest,
): Promise<PaginationSearchResult> => {
  const res = await deliveryNoteBusiness.getLists({
    filter: keyword,
    maxResultCount: request.pageSize,
    skipCount: request.pageIndex * request.pageSize,
    sorting: "",
  });

  return {
    items: mapToDistinctOptionItems(
      res.items?.filter((x) => x.number),
      (x) => x.number,
    ),
    totalCount: res.totalCount,
  };
};
